import React, { Component } from 'react';
import { CssBaseline, Grid, withStyles, Button } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
const moment = require('moment');

const StyledTableCell = withStyles((theme) => ({
  head: {
    color: '#1f1f1f',
    border: 'none',
    padding: '8px 16px',
    borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
  },
  body: {
    border: 'none',
    fontSize: 14,
    borderBottom: '1px solid rgba(0, 0, 0, 0.1)',

    [theme.breakpoints.down('sm')]: {
      // padding: "8px 0",
      fontSize: '13px',
    },
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {},
}))(TableRow);

const styles = (theme) => ({
  table: {
    border: 'none',
    borderTop: `3px solid ${theme.palette.primary.main}`,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
  },
  evtInfoRowWeb: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  evtInfoRowMobile: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'table-row',
    },
  },
  button: {
    backgroundColor: theme.palette.primary.main,
    color: '#ffffff',
    fontWeight: 'bold',
    fontSize: '1rem',
  },
});

class EvtNotiDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      matches: window.matchMedia('(max-width:600px)').matches,
    };
  }

  sendState = (event) => {
    // event.preventDefault();
    this.props.changeState('list');
  };

  render() {
    const { classes, selectedItem } = this.props;
    // console.log(this.props.selectedItem);

    return (
      <React.Fragment>
        <CssBaseline />
        <Grid container style={{ minHeight: '60vh' }}>
          <TableContainer component={Paper} style={{ boxShadow: 'none', borderRadius: 0, marginBottom: '1em' }}>
            <Table className={classes.table}>
              <TableHead>
                <React.Fragment>
                  <StyledTableRow>
                    <StyledTableCell
                      component="th"
                      width="30%"
                      align="center"
                      style={{
                        backgroundColor: 'rgba(29, 27, 84, 0.3)',
                        fontWeight: 'bold',
                        textAlign: 'center',
                      }}
                    >
                      제목
                    </StyledTableCell>
                    <StyledTableCell component="th" width="70%" align="left">
                      {selectedItem.title}
                    </StyledTableCell>
                  </StyledTableRow>
                  <StyledTableRow>
                    <StyledTableCell
                      component="th"
                      width="30%"
                      align="center"
                      style={{
                        backgroundColor: 'rgba(29, 27, 84, 0.3)',
                        fontWeight: 'bold',
                        textAlign: 'center',
                      }}
                    >
                      등록일
                    </StyledTableCell>
                    <StyledTableCell component="th" width="70%" align="left">
                      {moment(Number(selectedItem.createdAt)).format('YYYY-MM-DD')}
                    </StyledTableCell>
                  </StyledTableRow>
                </React.Fragment>
              </TableHead>
              <TableBody>
                <TableRow>
                  <StyledTableCell colSpan={4}>
                    <Grid container style={{ minHeight: '40vh' }}>
                      <div dangerouslySetInnerHTML={{ __html: selectedItem.content }} />
                    </Grid>
                  </StyledTableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>

          <Grid item xs={12}>
            <Grid container justify="flex-end">
              <Button className={classes.button} onClick={this.sendState}>
                목록
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(EvtNotiDetail);
